import React from 'react';
import '../../styles/LlenarDatosError.css';

//Imagenes
import ejemplo from '../../imgs/instruccionesFormulario/Captura de pantalla de 2023-01-18 00-03-09.png';


export default function LlenarDatosError(props) {

    return (
        <div className='llenar__div--container'>
            <div className='llenar__div--tarjeta'>
                <div className='llenar__div--cerrar' onClick={() => props.cerrarAlerta()}></div>
                <div className='llenar__div--container-titulo'>
                    <h2 className='llenar__h2'>Alerta!!!</h2>
                </div>
                
                <h3>Ups, te falto algo</h3>
                <p>Debes llenar correctamente los datos como aparece en la imagen </p>
                <img src={ejemplo} alt='imagen-ejemplo'/>
            </div>
        </div>
    )
}
